// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-text: #000;
  --color-text-p2: rgba(0 0 0 / 62%);
  --color-border-form: rgba(0 0 0 / 42%);
  --color-border: rgba(0 0 0 / 20%);
  --color-border-p2: rgba(0 0 0 / 10%);
  --color-icon: rgba(0 0 0 / 62%);
  --color-link: #2f609f;
  --color-link-current: #fff;
  --color-link-visited: #4f2bbb;
  --color-link-visited-current: #fff;
  --color-fill: rgba(0 0 0 / 3%);
  --color-fill-table-row-odd: rgba(0 0 0 / 8%);
  --color-fill-table-row-even: rgba(0 0 0 / 3%);
  --color-fill-form-element: var(--color-fill);
  --color-fill-current: rgba(0 0 0 / 62%);
  --color-fill-disabled: rgba(0 0 0 / 15%);
  --color-fill-hover: rgba(37 118 195 / 20%);
  --color-fill-focus: rgba(37 118 195 / 30%);
  --color-fill-focus-current: rgb(116 173 191);
  --color-fill-active: var(--primary);
  --highlighter-fill: #fc0;
  --shadow: 0 4px 32px rgba(0 0 0 / 17.5%);
  --bg: #fff;
  --bg-hover: color-mix(
    in oklch,
    oklch(from var(--bg) calc(l - 60) c h) 10%,
    var(--bg) 90%
  );
  --checkable-disabled-fill: #808080;
  --primary: #3992a9;

  /* --primary: #1960a4; */
  --secondary: #999;
  --error: #900;
  --error-fill: rgba(149 29 18 / 20%);
  --danger: #900;
  --warn: #943e00;
  --warn-fill: rgba(215 137 88 / 20%);
  --success: #070;
  --success-fill: rgba(51 117 30 / 20%);
  --control-margin-bottom: 1rem;
  --control-min-size-touch: 44px;
  --control-min-size-desktop: 24px;
  --control-label-margin-bottom: 0.25rem;
  --radius: 6px;
  --gutter: 1rem;
  --gutter-static: 15px;
  --gutter-static-one-third: calc(var(--gutter-static) / 3);
  --gutter-static-two-thirds: calc(var(--gutter-static-one-third) * 2);
  --input-horizontal-padding: var(--gutter-static-one-third);
  --input-vertical-padding: 0;
  --container-max-width: 80rem;
  --page-margin-default: 0.4in;

  /**
   * Font-size
   * Size ratios from Fonts Module Level 3
   * https://www.w3.org/TR/css-fonts-3/#propdef-font-size
   */
  --line-height: 1.5;
  --font-size-x-small: 0.8571rem;
  --font-size-small: 0.8571rem;
  --font-size-medium: 1rem;
  --font-size-large: 1.3rem;
  --font-size-x-large: 1.7143rem;
  --font-size-xx-large: 2.2858rem;
  --font-size-form-label: 1.05rem;

  /**
   * Font-weights
   */
  --text-weight-black: 900;
  --text-weight-bold: 700;
  --text-weight-medium: 600;
  --text-weight-regular: 400;
  --text-weights-are-bolder: 0;
  --text-weight-basis: var(--text-weight-regular);
  --text-weight-addition-factor: 200;
  --text-weight-headline-basis: 600;
  --text-weight-headline-addition-factor: 100;
  --text-weight: calc(
    var(--text-weight-basis) +
      (var(--text-weight-addition-factor) * var(--text-weights-are-bolder))
  );
  --text-weight-headline: var(--text-weight-bold);
  --text-weight-button: var(--text-weight-bold);
}

/* Lean on min-width queries to create mobile-first CSS. */
@custom-media --small-up (min-width: 321px);
@custom-media --medium-up (min-width: 641px);
@custom-media --large-up (min-width: 1025px);
@custom-media --x-large-up (min-width: 1441px);
@custom-media --xx-large-up (min-width: 1921px);

/* Use these max-width queries as infrequently as possible. */
@custom-media --small (max-width: 640px);
@custom-media --medium-down (max-width: 1024px);
@custom-media --medium (min-width: 641px) and (max-width: 1024px);
@custom-media --large (min-width: 1025px) and (max-width: 1440px);
@custom-media --x-large (min-width: 1441px) and (max-width: 1920px);
`, "",{"version":3,"sources":["webpack://./../stripes-components/lib/variables.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,sCAAsC;EACtC,iCAAiC;EACjC,oCAAoC;EACpC,+BAA+B;EAC/B,qBAAqB;EACrB,0BAA0B;EAC1B,6BAA6B;EAC7B,kCAAkC;EAClC,8BAA8B;EAC9B,4CAA4C;EAC5C,6CAA6C;EAC7C,4CAA4C;EAC5C,uCAAuC;EACvC,wCAAwC;EACxC,0CAA0C;EAC1C,0CAA0C;EAC1C,4CAA4C;EAC5C,mCAAmC;EACnC,wBAAwB;EACxB,wCAAwC;EACxC,UAAU;EACV;;;;GAIC;EACD,kCAAkC;EAClC,kBAAkB;;EAElB,wBAAwB;EACxB,iBAAiB;EACjB,aAAa;EACb,mCAAmC;EACnC,cAAc;EACd,eAAe;EACf,mCAAmC;EACnC,eAAe;EACf,qCAAqC;EACrC,6BAA6B;EAC7B,8BAA8B;EAC9B,gCAAgC;EAChC,sCAAsC;EACtC,aAAa;EACb,cAAc;EACd,qBAAqB;EACrB,yDAAyD;EACzD,oEAAoE;EACpE,0DAA0D;EAC1D,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;;EAE5B;;;;IAIE;EACF,kBAAkB;EAClB,8BAA8B;EAC9B,4BAA4B;EAC5B,wBAAwB;EACxB,yBAAyB;EACzB,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;;EAE/B;;IAEE;EACF,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;EAC5B,+CAA+C;EAC/C,kCAAkC;EAClC,iCAAiC;EACjC,2CAA2C;EAC3C;;;GAGC;EACD,+CAA+C;EAC/C,6CAA6C;AAC/C;;AAEA,0DAA0D;AAC1D,2CAA2C;AAC3C,4CAA4C;AAC5C,4CAA4C;AAC5C,8CAA8C;AAC9C,+CAA+C;;AAE/C,6DAA6D;AAC7D,wCAAwC;AACxC,+CAA+C;AAC/C,iEAAiE;AACjE,iEAAiE;AACjE,mEAAmE","sourcesContent":[":root {\n  --color-text: #000;\n  --color-text-p2: rgba(0 0 0 / 62%);\n  --color-border-form: rgba(0 0 0 / 42%);\n  --color-border: rgba(0 0 0 / 20%);\n  --color-border-p2: rgba(0 0 0 / 10%);\n  --color-icon: rgba(0 0 0 / 62%);\n  --color-link: #2f609f;\n  --color-link-current: #fff;\n  --color-link-visited: #4f2bbb;\n  --color-link-visited-current: #fff;\n  --color-fill: rgba(0 0 0 / 3%);\n  --color-fill-table-row-odd: rgba(0 0 0 / 8%);\n  --color-fill-table-row-even: rgba(0 0 0 / 3%);\n  --color-fill-form-element: var(--color-fill);\n  --color-fill-current: rgba(0 0 0 / 62%);\n  --color-fill-disabled: rgba(0 0 0 / 15%);\n  --color-fill-hover: rgba(37 118 195 / 20%);\n  --color-fill-focus: rgba(37 118 195 / 30%);\n  --color-fill-focus-current: rgb(116 173 191);\n  --color-fill-active: var(--primary);\n  --highlighter-fill: #fc0;\n  --shadow: 0 4px 32px rgba(0 0 0 / 17.5%);\n  --bg: #fff;\n  --bg-hover: color-mix(\n    in oklch,\n    oklch(from var(--bg) calc(l - 60) c h) 10%,\n    var(--bg) 90%\n  );\n  --checkable-disabled-fill: #808080;\n  --primary: #3992a9;\n\n  /* --primary: #1960a4; */\n  --secondary: #999;\n  --error: #900;\n  --error-fill: rgba(149 29 18 / 20%);\n  --danger: #900;\n  --warn: #943e00;\n  --warn-fill: rgba(215 137 88 / 20%);\n  --success: #070;\n  --success-fill: rgba(51 117 30 / 20%);\n  --control-margin-bottom: 1rem;\n  --control-min-size-touch: 44px;\n  --control-min-size-desktop: 24px;\n  --control-label-margin-bottom: 0.25rem;\n  --radius: 6px;\n  --gutter: 1rem;\n  --gutter-static: 15px;\n  --gutter-static-one-third: calc(var(--gutter-static) / 3);\n  --gutter-static-two-thirds: calc(var(--gutter-static-one-third) * 2);\n  --input-horizontal-padding: var(--gutter-static-one-third);\n  --input-vertical-padding: 0;\n  --container-max-width: 80rem;\n  --page-margin-default: 0.4in;\n\n  /**\n   * Font-size\n   * Size ratios from Fonts Module Level 3\n   * https://www.w3.org/TR/css-fonts-3/#propdef-font-size\n   */\n  --line-height: 1.5;\n  --font-size-x-small: 0.8571rem;\n  --font-size-small: 0.8571rem;\n  --font-size-medium: 1rem;\n  --font-size-large: 1.3rem;\n  --font-size-x-large: 1.7143rem;\n  --font-size-xx-large: 2.2858rem;\n  --font-size-form-label: 1.05rem;\n\n  /**\n   * Font-weights\n   */\n  --text-weight-black: 900;\n  --text-weight-bold: 700;\n  --text-weight-medium: 600;\n  --text-weight-regular: 400;\n  --text-weights-are-bolder: 0;\n  --text-weight-basis: var(--text-weight-regular);\n  --text-weight-addition-factor: 200;\n  --text-weight-headline-basis: 600;\n  --text-weight-headline-addition-factor: 100;\n  --text-weight: calc(\n    var(--text-weight-basis) +\n      (var(--text-weight-addition-factor) * var(--text-weights-are-bolder))\n  );\n  --text-weight-headline: var(--text-weight-bold);\n  --text-weight-button: var(--text-weight-bold);\n}\n\n/* Lean on min-width queries to create mobile-first CSS. */\n@custom-media --small-up (min-width: 321px);\n@custom-media --medium-up (min-width: 641px);\n@custom-media --large-up (min-width: 1025px);\n@custom-media --x-large-up (min-width: 1441px);\n@custom-media --xx-large-up (min-width: 1921px);\n\n/* Use these max-width queries as infrequently as possible. */\n@custom-media --small (max-width: 640px);\n@custom-media --medium-down (max-width: 1024px);\n@custom-media --medium (min-width: 641px) and (max-width: 1024px);\n@custom-media --large (min-width: 1025px) and (max-width: 1440px);\n@custom-media --x-large (min-width: 1441px) and (max-width: 1920px);\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
